<template>
  <div
    class="sticky"
    ref="el"
    draggable
    @dragstart="start"
    @dragend="end"
    :class="{ isDragging }"
    v-bind="$attrs"
  >
    <!-- @drag="move" -->
    <slot></slot>
  </div>
</template>

<script>
// import { createThrottle } from '@/utils/util';
// const throttle = createThrottle(50);
export default {
  data() {
    return {
      isDragging: false,
      initialX: 0,
      initialY: 0,
    };
  },
  methods: {
    start(e) {
      this.initialX += e.clientX;
      this.initialY += e.clientY;
      this.isDragging = true;
    },
    // move(e) {
    //   throttle(() => {});
    //   this.setTranslate(e.clientX - this.initialX, e.clientY - this.initialY);
    // },
    end(e) {
      this.setTranslate(e.clientX - this.initialX, e.clientY - this.initialY);
      this.initialX = this.initialX - e.clientX;
      this.initialY = this.initialY - e.clientY;
      this.isDragging = false;
    },
    setTranslate(xPos, yPos) {
      this.$el.style.transform =
        'translate3d(' + xPos + 'px, ' + yPos + 'px, 0)';
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky {
  position: absolute;
  z-index: 9999999999999999;
  transition: transform 0.3s;
  user-select: none;
  * {
    cursor: grabbing;
  }
}
</style>
